import { useContext } from 'react';
import { useQuery } from 'react-query';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { ace_index_api } from '@axo/shared/data-access/api';
import { ace_index } from '@axo/shared/data-access/types';
import { aceIndexKeys } from '../../cache-keys/aceIndexKeys';

export function useWorkingLists(aud?: ace_index.Audience) {
  const api = useAPI();

  const ctx = useContext(DataAccessContext);
  const token = ctx?.state?.user?.token ?? '';

  return useQuery({
    queryKey: aceIndexKeys.workingLists(aud),
    queryFn: ({ queryKey: [, , aud] }) =>
      ace_index_api.findWorkingList(api)(aud),
    enabled: token.length > 0,
  });
}
